import {
  ROUTES,
} from './routes';

export const QUICK_MENU_ITEMS =
  Object.freeze([
    {
      id: 'resources',
      translationKey:
        'quickMenu.download',
      icon: 'download',
      path: ROUTES.resources,
      visible: true,
    },

    {
      id: 'signup',
      translationKey:
        'quickMenu.signup',
      icon: 'user',
      path: ROUTES.signup,
      visible: true,
    },

    {
      id: 'updatenotices',
      translationKey:
        'quickMenu.updatenotices',
      icon: 'user',
      path: ROUTES.updatenotices,
      visible: true,
    },
  ]);

export const BRAND_FEATURES =
  Object.freeze([
    {
      id:
        'software-management',

      translationKey:
        'brand.features.softwareManagement',
    },

    {
      id:
        'technical-document',

      translationKey:
        'brand.features.technicalDocument',
    },

    {
      id:
        'user-support',

      translationKey:
        'brand.features.userSupport',
    },
  ]);

export const LOGIN_STORAGE_KEY =
  'hanwha-semitech-software-platform:remembered-user-id';